import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./Our_Services.css";
import How_It_Works_card from "../../../Common_Component/How_It_Works_card/How_It_Works_card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function Our_Services() {
  const [serviceData, setServiceData] = useState([]);
  const { id } = useParams(); // Get 'id' from the URL params

  // Static data array
  const data = [
    {
      id: 2,
      data: [
        {
          numberText: "1",
          headingText: "Social Media Creatives",
          text: "Engaging posts, banners, and ads to grow your online presence.",
        },
        {
          numberText: "2",
          headingText: "Marketing Collaterals",
          text: "Brochures, flyers, posters, and business cards that leave an impression.",
        },
        {
          numberText: "3",
          headingText: "Branding Assets",
          text: "Logos, letterheads, packaging, and more to establish a cohesive identity.",
        },
        {
          numberText: "4",
          headingText: "Infographics",
          text: "Visual representations of data and ideas to simplify complex information.",
        },
        {
          numberText: "5",
          headingText: "Website & App Graphics",
          text: "Eye-catching UI/UX elements that enhance user experience.",
        },
      ],
    },

    {
      id: 3,
      data: [
        {
          numberText: "1",
          headingText: "Logo Design",
          text: "A unique, memorable logo that defines your brand.",
        },
        {
          numberText: "2",
          headingText: "Colour Palette Creation",
          text: "A harmonious colour scheme that evokes the right emotions.",
        },
        {
          numberText: "3",
          headingText: "Typography Selection",
          text: "Fonts that complement your brand’s tone and aesthetics.",
        },
        {
          numberText: "4",
          headingText: "Visual Elements",
          text: "Icons, patterns, and graphic elements to enrich your brand.",
        },
        {
          numberText: "5",
          headingText: "Marketing Materials",
          text: "Business cards, letterheads, social media templates, and more.",
        },
        {
          numberText: "6",
          headingText: "Brand Style Guide",
          text: "A comprehensive manual for consistent branding across all platforms.",
        },
      ],
    },
  ];

  // Filter the data based on the 'id' from the URL
  useEffect(() => {
    const filteredArray = data.filter((item) => item.id === Number(id));
    setServiceData(filteredArray);
  }, [id]);

  return (
    <section className="How_It_Works">
      <div className="container">
        <div className="heading_holder">
          <h4>Our Services</h4>
        </div>
        <Swiper
          className="mySwiper"
          slidesPerView={5}
          spaceBetween={10}
          breakpoints={{
            320: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 25,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
          }}
        >
          {serviceData.length > 0 &&
            serviceData[0].data.map((item, index) => (
              <SwiperSlide key={index}>
                <How_It_Works_card
                  numberText={item.numberText}
                  headingText={item.headingText}
                  text={item.text}
                />
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Our_Services;
